const indexes = [
  { title: '热门娱乐', count: 1283, icon: 'ri-movie-line' },
  { title: '影视剧集', count: 967, icon: 'ri-tv-line' },
  { title: '综艺八卦', count: 854, icon: 'ri-emotion-laugh-line' },
  { title: '明星动态', count: 721, icon: 'ri-star-line' },
  { title: '社会热点', count: 693, icon: 'ri-fire-line' },
  { title: '行业吃瓜', count: 542, icon: 'ri-briefcase-line' },
  { title: '数码科技', count: 478, icon: 'ri-computer-line' },
  { title: '体育赛事', count: 405, icon: 'ri-basketball-line' },
  { title: '海外资讯', count: 367, icon: 'ri-global-line' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6">
        <div className="flex items-center gap-3 mb-10">
          <span className="w-8 h-8 rounded-lg bg-primary-500/15 flex items-center justify-center flex-shrink-0">
            <i className="ri-grid-line text-primary-400"></i>
          </span>
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-100">主题索引</h2>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 gap-3 md:gap-4">
          {indexes.map((item) => (
            <a
              key={item.title}
              href="#index"
              onClick={(e) => e.preventDefault()}
              className="group flex items-center gap-3 p-4 rounded-xl bg-background-100 border border-background-300/30 hover:border-primary-500/20 hover:bg-background-200/70 transition-all duration-200 cursor-pointer"
            >
              <span className="w-10 h-10 rounded-lg bg-primary-500/10 flex items-center justify-center flex-shrink-0 group-hover:bg-primary-500/20 transition-colors">
                <i className={`${item.icon} text-primary-400`}></i>
              </span>
              <div className="flex-1 min-w-0">
                <span className="text-sm md:text-base font-medium text-foreground-300 block truncate">{item.title}</span>
                <span className="text-xs text-foreground-600">{item.count} 条内容</span>
              </div>
              <i className="ri-arrow-right-s-line text-foreground-600 opacity-0 group-hover:opacity-100 transition-opacity"></i>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}